// extracted by mini-css-extract-plugin
export default {"linkWrapper":"InfoElement_linkWrapper__ZOAcp","button":"InfoElement_button__RbvL6","greenIcon":"InfoElement_greenIcon__cqgDB"};